import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import { PlusCircleFill } from "react-bootstrap-icons";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Training } from "../Training/trainingTable";
import { HiArrowSmallLeft } from "react-icons/hi2";

interface QuizData {
    id: number,
    folder_name: string,
    quizCount: number
}

const QuizDatas = () => {
  const { id } = useParams<{ id: string }>();
  const [quizData, setQuizData] = useState<QuizData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchQuizData = async () => {
      try {
        const trainingId = Number(id);
        const response = await postDetails(APIList.GETALL_TRAININING_CONTENT, { training_id: trainingId });
        console.log(response);

        // Check if the response contains the data array
        if (response.data && Array.isArray(response.data)) {
          // Extract and aggregate folderData from each item in the data array
          const aggregatedFolderData: QuizData[] = response.data.flatMap((item: any) => item.folderData || []);
          
          if (aggregatedFolderData.length > 0) {
            setQuizData(aggregatedFolderData);
          } else {
            setError("No Quiz Data found.");
          }
        } else {
          setError("No Quiz Data found.");
        }
      } catch (err) {
        setError("Failed to fetch Quiz data.");
        console.error("Error fetching Quiz data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchQuizData();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const columns: TableColumn[] = [
    // { key: "id", label: "id", sortable: true },
    { key: "folder_name", label: "Folder Name", sortable: true },
    { key: "quizCount", label: "Quiz Count", sortable: true },
  ];
  const handleAddNewTraining = () => {
    navigate(`/trainings`); 
  
  };
  
  const buttons = [
    {
      label: "Back to Training",
      theme: "warning",
      icon: <HiArrowSmallLeft />,
      onClick: handleAddNewTraining,
    },
  ];
  return (
    <LayoutContainer title={"Training"}>
    <div>
     <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-dashboard"></i>
          Quiz Data
        </h2>

        <PageHeader buttons={buttons} />
      </div>
      <CommonTable<QuizData>
        data={quizData}
        columns={columns}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: false,
          delete: false,
          checkbox: false,
          status: false,
          showModal: false,
        }}
      />
    </div>
    </LayoutContainer>
  );
};

export default QuizDatas;
